// removed by extract-text-webpack-plugin
module.exports = {"stepPanel":"ContactInfo__stepPanel___34qB7 stepPanel__stepPanel___1Vrm5 layout__panel___vsQZV","row":"ContactInfo__row___Zxi8S","orcidButton":"ContactInfo__orcidButton___30fvP","cityField":"ContactInfo__cityField___3Gc0j","stateField":"ContactInfo__stateField___1UTJc","postalCodeField":"ContactInfo__postalCodeField___2Oy9O"};


//////////////////
// WEBPACK FOOTER
// ./src/contact-info/components/ContactInfo.css
// module id = 747
// module chunks = 0